import { Message, MessageBox } from 'element-ui'
import { clearEmptyKey, deepFreeze } from '@/utils/objUtil'
import albumService from '@/api/album.js'
import { getDiffObj, diffArray } from '@/views/track/const'
export {
  copyrightAreaMap,
  languageMap,
  areaList,
  areaMap,
  licenseFileType,
  trackType,
  imageType,
  lyricType,
  statusIconMap,
  hasSubGenreSet
} from '@/utils/constants'

export { subGenreMap, genreMap } from '@/utils/constants'
export { getDiffObj, diffArray }

const freeze = Object.freeze

export const cdMap = freeze((new Array(100)).fill(null).reduce((result, item, index) => {
  const key = index
  result[key] = `CD${key + 1}`
  return result
}, {}))

export const trackStatusToAlbumStatus = freeze({
  0: 1,
  1: 5,
  2: 2
})

export const statusMap = freeze({
  0: '全部',
  1: '待上架',
  2: '已下架',
  3: '审核中',
  4: '不通过',
  5: '已上架',
})

export const srcGenreList = [
  'Pop', 'Classical', 'Jazz', 'Blues', 'Children\'s', 'Country', 'Dance', 'Easy', 'Listening', 'Electronic',
  'Folk', 'Holiday', 'Latin', 'Metal', 'New', 'Age', 'R&b', 'Soul', 'Rap/hip', 'Hop', 'Reggae', 'Rock',
  'Soundtrack', 'World', 'Music', 'Punk', 'Alternative', 'Experimental', 'Spoken&audio', 'Religious'
]

export const typeList = [
  {
    id: 0,
    name: 'album',
    disabled: false
  }, {
    id: 10,
    name: 'single',
    disabled: false
  }, {
    id: 11,
    name: 'EP',
    disabled: false
  }
]
export const typeMap = typeList.reduce((result, item) => {
  result[item.id] = item.name
  return result
}, {})
export const lyricFromMap = freeze({
  0: '未知',
  1: '唱片公司提供',
  2: 'TME音乐人上传',
  3: '合作平台上传',
  4: '互联网获取',
  5: '供应商提供',
  7: '数字音乐管理平台上传',
  8: '智能制作',
  9: '平台获取',
})

export const lyricList = deepFreeze([
  {
    name: '文本歌词TXT',
    key: 'lyricTxt',
    accept: ['.txt']
  },
  {
    name: '逐行歌词LRC',
    key: 'lyricLrc',
    accept: ['.txt', '.lrc']
  },
  {
    name: '逐字歌词TRC',
    key: 'lyricQrc',
    accept: ['.txt']
  },
  {
    name: '翻译歌词',
    key: 'lyricTrans',
    accept: ['.txt']
  },
  {
    name: '音译歌词',
    key: 'lyricRoma',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '假名歌词',
    key: 'lyricKana',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '酷狗逐字歌词',
    key: 'lyricKugou',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '酷狗音译逐字歌词',
    key: 'lyricKugouRoma',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '酷我逐字歌词',
    key: 'lyricKuwo',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '酷我音译逐字歌词',
    key: 'lyricKuwoRoma',
    accept: ['.txt'],
    hidden: true
  },
  {
    name: '音译逐行歌词',
    key: 'lyricLrcRoma',
    accept: ['.txt'],
    hidden: true
  },
])

// 版权相关
export const cpSourceMap = {
  1: '免费授权',
  2: '签约上架',
}
export const isAgentMap = {
  0: '自有',
  1: '代理'
}

export const canAuthMap = {
  0: '不可',
  1: '可',
}

export const isOnlyMap = {
  0: '非总代理',
  1: '总代理',
}

export const paymentMap = freeze({
  1: '免费',
  3: '1.0',
  5: '2.0',
  10: '3.0',
  // 14: '数字专辑',
  15: '2.0转3.0',
})

// 内容管理-歌曲管理-付费口径
export const checkPaymentMap = freeze({
  1: '免费',
  3: '1.0',
  5: '2.0',
  10: '3.0',
})

// 付费类型
export const paymentTypeMap = {
  0: '免费',
  1: '付费1.0',
  2: '付费2.0',
  3: '付费3.0',
  4: '数字专辑',
  // 5: '长音频',
  6: '数字藏品',
}

export const isOverseaMap = {
  0: '不是',
  1: '是',
}
export const canCoverMap = freeze({
  2: '否',
  1: '是'
})
export const canLegalRightsMap = freeze({
  0: '否',
  1: '是'
})
export const licenseValidMap = freeze({
  1: '是',
  2: '否'
})
export const contractTypeMap = freeze({
  1: '词曲授权',
  2: '录音附带'
})

export const defaultWMCopyright = freeze({
  cpCompany: '',
  originCpCompany: {
    companyName: '',
  },
  date: [],
  cpPercent: 0,
  isAgent: 0,
  isOnly: 0,
  canAuth: 0,
  copyrightArea: [],
  cpSource: 2,
  isOverseaOnly: 0,
  editCopyright: '',
  canCover: 2,
  licenseValid: 2,
  // canLegalRights: 0,
  contractType: 1,

  wordFileList: [],
  musicFileList: []
})

export const instrumentMap = freeze({
  leadSinger: '领唱',
  accompaniment: '伴唱',
  band: '乐队',
  guitar: '吉他',
  electricGuitar: '电吉他',
  keyboard: '键盘',
  cello: '大提琴',
  viola: '中提琴',
  violin: '小提琴',
  piano: '钢琴',
  organ: '风琴',
  harp: '竖琴',
  xylophone: '木琴',
  drum: '鼓',
  saxphone: '萨克斯风',
  trumpet: '小号',
  large: '大号',
  trombone: '长号',
  horn: '圆号',
  oboe: '双簧管',
  flute: '长笛',
  bass: '贝斯',
  soundtrack: '配乐',
  discs: '打碟 DJ',
  director: '导演',
  female_voice: '女声',
  male_voice: '男声',
  harmony: '和声',
  harmonyPrepared: '和声编写',
  chorusProducer: '配唱制作人',
  mixingEngineer: '混音工程师',
  masterEngineer: '母带工程师',
  recorder: '录音师',
  musicRecorder: '乐器录音师',
  studio: '录音室',
  vocalRecordingStudio: 'Vocal录音室',
  musicalInstrumentRecordingStudio: '乐器录音室',
  command: '指挥',
  narrator: '讲述者',
  mixing: '缩混',
  harpGuitar: '竖琴吉他',
  executiveProducer: '监制',
  arrangerAssistant: '编曲助理',
  chorus: '合声',
  chorusPrepared: '合声编写',
  guzheng: '古筝',
  erhu: '二胡',
  string: '弦乐',
  xixingStudio: '混音室',
  xasterStudio: '母带工作室',
  overallPlanning: '统筹',
  audioDirector: '音响总监',
  produced: '出品',
  lute: '琵琶',
  bambooFlute: '竹笛',
  musicDesign: '音乐设计',
  japaneseZither: '日本筝',
  cymbals: '钹',
  dulcimer: '扬琴',
  vocal: 'Vocal',
  mixed: '混编',
  adaptation: '改编',
  inscription: '题字',
  copywriting: '文案',
  jifou: '击缶',
  xiao: '箫',
  proofreading: '校对',
  chief: '首席',
  ruan: '阮',
  chineseDrum: '中国鼓',
  cha: '镲',
  sampling: '采样',
  writingPoetry: '作诗',
  verb: '填词',
  caption: '题注',
  clarinet: '单簧管',
  rap: '饶舌',
  orchestrator: '配器师',
  track: '分轨',
  piccolo: '短笛',
  solo: '独奏',
  monologue: '独白',
})

export const srcVersionList = freeze([
  {
    name: '完整版',
    desc: '无裁剪、重新混音等操作的完整原版歌曲',
  },
  {
    name: 'Explicit',
    desc: '家长指引相关内容，如果有儿童不宜的内容，需尽量在版本上标明Explicit版',
  },
  {
    name: 'Live',
    desc: '来自现场录制的歌曲版本',
  },
  {
    name: '伴奏',
    desc: '伴随衬托人声演唱的和声旋律，一般无人声，或有和声伴唱',
  },
  {
    name: 'Remix',
    desc: '重混，指复制歌曲的原始版本，经过重新混音，以及重新编写歌词，形成另一种版本',
  },
  {
    name: 'DJ版',
    desc: '在原曲的基础上加上电子合成器、效果器、鼓机等“乐器”所产生的电子声响合成版本',
  },
  {
    name: 'Radio Edit',
    desc: '电台编辑版，指在长度，亵渎，主题，乐器或形式上都更适合电台播放',
  },
  {
    name: 'Demo',
    desc: '样本唱片，指歌曲在正式发行前唱片来提供参考的版本',
  },
  {
    name: 'Acoustic',
    desc: '由原声乐器伴奏录音室录制的歌曲版本',
  },
  {
    name: '纯音乐',
    desc: '原曲的纯音乐版本，或歌曲本身为纯音乐',
  },
  {
    name: 'Remaster',
    desc: '母带重制版本',
  },
  {
    name: '加长版',
    desc: '既加长版或延长版，指在原曲的基础上延长前奏、间奏或尾奏的歌曲版本',
  },
  {
    name: 'Single Version',
    desc: '指该歌曲以单曲形式发行',
  },
  {
    name: '口白',
    desc: '曲目中大量的人物内心独白或两者对话',
  },
  {
    name: 'Clean',
    desc: '对演唱歌词中的粗口内容做过消音处理的歌曲版本',
  },
  {
    name: '不插电版',
    desc: '同Unplugged，指不使用电子乐器，不经过电子设备的修饰加工的表演形式',
  },
  {
    name: '试听版',
    desc: '从正式版中截取的供用户试听的音乐片段',
  },
  {
    name: '长音频',
    desc: '由主播（一人或多人）根据特定的文本内容，用不同的语气、声调等进行演绎的录音作品',
  },
  {
    name: '翻唱版',
    desc: '指将已经发表并由他人演唱的歌曲根据自己的风格重新演唱，或重新演奏的版本',
  },
  {
    name: 'MV版',
    desc: '配合歌曲MV的版本，可能包含口白等剧情元素',
  }
])

export const versionMap = freeze([
  {
    label: 'AI生成',
    value: 13,
  },
  {
    label: '无',
    value: 0,
    disabled: false
  },
  {
    label: '影视',
    value: 2,
    disabled: false
  },
  {
    label: '综艺',
    value: 3,
    disabled: false
  },
  {
    label: 'ACG',
    value: 12,
    disabled: false
  },
  {
    label: '精选',
    value: 1,
    disabled: true
  },
  {
    label: '现场',
    value: 4,
    disabled: true
  },
  {
    label: '长音频',
    value: 5,
    disabled: true
  },
  {
    label: 'DEMO',
    value: 6,
    disabled: true
  },
  {
    label: 'REMIX',
    value: 7,
    disabled: true
  },
  {
    label: 'Special Edition',
    value: 8,
    disabled: true
  },
  {
    label: 'Deluxe',
    value: 9,
    disabled: true
  },
  {
    label: 'Clean',
    value: 10,
    disabled: true
  },
  {
    label: 'Explicit',
    value: 11,
    disabled: true
  },
])

export async function checkAlbumModify(albumObj) {
  const oldLockObj = albumObj.oldLockObj
  const {
    albumPhotoList,
    albumSingerList,
    albumLicenseList,
  } = albumObj
  const modifyObj = {}

  // 基础信息
  const baseDiffObj = getDiffObj(oldLockObj, albumObj, ['albumName', 'displayCompanyName', 'publicTime', 'albumDesc'])
  if (baseDiffObj) {
    modifyObj.album = {
      id: albumObj.albumId,
      ...baseDiffObj
    }
  }

  // 歌手
  modifyObj.albumSingerList = diffArray(oldLockObj.albumSingerList, albumSingerList)

  // 封面
  modifyObj.albumPhotoList = diffArray(oldLockObj.albumPhotoList, albumPhotoList)

  // 扩展字段

  if (clearEmptyKey(modifyObj)) {
    modifyObj.albumId = albumObj.albumId
    modifyObj.albumLicenseList = albumLicenseList

    // 校验敏感词
    try {
      const result = await albumService.checkModifySensitive({
        fType: 0,
        ...modifyObj
      })
      if (!result.checkSign) {
        throw new Error(`输入包含敏感词! ${JSON.stringify(result.res)}`)
      }
    } catch (error) {
      MessageBox.alert(error.message, '错误', {
        type: 'error'
      })
      throw error
    }

    albumService.applyModifyAlbum(modifyObj).then(resp => {
      return Promise.resolve(true)
    }).catch(error => {
      Message.error(`提交字段修改请求异常(${error.message})`)
    })
  }
}
